export { default as enUS } from "./en-US.js";

// Export resources in i18next format
import enUS from "./en-US.js";

export const resources = {
  "en-US": {
    translation: enUS,
  },
};

// Default export for convenience
export default resources;
